import { createContext, ReactNode, useContext, useState } from 'react';
import { CustomsCommitteeFormFields } from '../model/customs-committee.schema';
import { TaxServiceFormFields } from '../model/tax-service.schema';

const StateFormContext = createContext<{
  state: {
    customs: CustomsCommitteeFormFields | null;
    tax: TaxServiceFormFields | null;
  };
  setState: React.Dispatch<
    React.SetStateAction<{
      customs: CustomsCommitteeFormFields | null;
      tax: TaxServiceFormFields | null;
    }>
  >;
  resetStore: () => void;
}>({
  state: { customs: null, tax: null },
  setState: () => {},
  resetStore: () => {},
});

export const StateFormProvider = ({ children }: { children: ReactNode }) => {
  const [state, setState] = useState({
    customs: null,
    tax: null,
  });

  const resetStore = () => {
    setState({
      customs: null,
      tax: null,
    });
  };

  return (
    <StateFormContext.Provider
      value={{
        state,
        setState,
        resetStore,
      }}
    >
      {children}
    </StateFormContext.Provider>
  );
};

export const useGovernmentPortalContext = () => useContext(StateFormContext);
